// 数量を連動させる商品
const bundleItemsQuantity = [
    '39357926408398', // ラッピング
    '41649568121038', // クリスマスラッピング
    '41091237249230', //母の日ラッピング
    '40315612823758', // Twitter IDがある方
    '42865896980686', //持ち手風ストラップ
    '42865897013454', //可変式ストラップ
    '42865897046222', // 持ち手風・可変式ストラップの2種セット
    '42877684973774', // 名入れ
    '42892899451086', // 長さ調整可能ストラップ
    '43039504728270'  //デコ取り付け（ホワイトフラワー）
];
// 同時購入ストラップ(snippets/strap-pairing.liquid)は、本体の行ごとに連動させる。
// 行の属性 data-strap-links(sections/main-cart-items.liquid)に、その本体が連動させる
// ストラップのバリエーションIDが入っている。カート全体の一覧にすると、既存オプションで
// 同じストラップを選んだ別の本体まで連動してしまうため
function strapLinksOfLine(line_key) {
    var row = $('tr.cart-item').filter(function () {
        return $(this).attr('data-line-key') === line_key;
    }).first();
    var data = row.attr('data-strap-links');
    if (!data) return [];
    return data.split(',').filter(function (id) { return id !== ''; });
}
function isLinkedBundleItem(line_key, variant_id) {
    var id = String(variant_id);
    return $.inArray(id, bundleItemsQuantity) !== -1 || $.inArray(id, strapLinksOfLine(line_key)) !== -1;
}

$(function(){
    $('html,body').animate({ scrollTop: 0 }, '1');
    // 数量変更ボタンを監視
    $(document).on('click', 'button.quantity__button', function(){
        // $(this).attr("name")) = `minus` or `plus`
        // $(this).parent().attr("name")) = `item.key`(行のキー)

        // バンドル商品をチェック
        checkBundleItem($(this).parent().attr("name"), $(this).attr("name"));
    });

    // 削除ボタンを監視
    $(document).on('click', 'a.button--tertiary', function(e){
        // $(this).attr("name")) = `item.key`(行のキー)
        // e.preventDefault();
        // バンドル商品をチェック
        checkDeleteBundleItem($(this).attr("name"));
    });
});

// 有料オプション商品の数量を変更
function changeCartOptionProduct(item) {
    // console.log('change item = '+JSON.stringify(item));
    var result = $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      async: false,
      data: item,
      dataType: 'json',
    }).responseText;

    // console.log('responseText = ' + JSON.stringify(result));
    return result;
}

// 付属品の行のいまの数量。
// 付属品の行は、数量固定の表示(.bundle-item-quantity-<id>)のことも、
// 数量を自分で変えられる通常の表示(.main-item-quantity-<id>)のこともある。
// シリーズ連動のストラップを単品でも買って行がまとまると後者になる
// (sections/main-cart-items.liquid)。どちらの形でも読めるようにする。
// 読めなければ 0 ではなく NaN を返し、呼び出し側で数量を書き換えない。
function bundleLineQuantity(variant_id) {
    var fixed = $('.bundle-item-quantity-' + variant_id);
    if (fixed.length) return Number(fixed.first().text());
    var input = $('.main-item-quantity-' + variant_id);
    if (input.length) return Number(input.first().val());
    return NaN;
}

// 本体の行に紐づく付属品 {名前: バリエーションID}。無ければ undefined。
// 行の属性(sections/main-cart-items.liquid の data-bundle-items)から、そのつど読む。
// 数量変更で行が再描画されても、そのときの行のキーで引けるようにするため
function bundleItemsOfLine(line_key) {
    var row = $('tr.cart-item').filter(function () {
        return $(this).attr('data-line-key') === line_key;
    }).first();
    var data = row.attr('data-bundle-items');
    if (!data) return undefined;
    try {
        return JSON.parse(data);
    } catch (e) {
        return undefined;
    }
}

// バンドル商品をチェック（数量変更）
// line_key は本体の行のキー(item.key)。バリエーションIDで引くと、同じ本体を
// 付属品ありとなしの別の行で入れたときに、もう一方の行の付属品を動かしてしまう
function checkBundleItem(line_key, minus_plus) {
    // バンドル商品情報がない場合はスキップ
    var bundleItems = bundleItemsOfLine(line_key);
    if (typeof( bundleItems ) == 'undefined') {
        return;
    }

    // 同じ本体が同じ付属品を複数回指すこともある(付属品も回数分入っている)。
    // 画面の数量は処理中に変わらないので、付属品ごとに回数をまとめてから1回で変更する
    var linkedCounts = {};
    $.each(bundleItems, function(index, value) {
        if (isLinkedBundleItem(line_key, value)) {
            linkedCounts[value] = (linkedCounts[value] || 0) + 1;
        }
    });
    $.each(linkedCounts, function(value, count) {
        var currentQuantity = bundleLineQuantity(value);
        var itemQuantity = (minus_plus == 'minus') ? currentQuantity - count : currentQuantity + count;
        // 付属品の行が見つからない(数量が読めない)ときは触らない。0や-1で上書きしないため
        if (isNaN(itemQuantity) || itemQuantity < 0) {
            return;
        }
        // バンドル商品の数量変更
        do {
            var result = changeCartOptionProduct( {id: value, quantity: itemQuantity} );
        } while ($.inArray('token', JSON.parse(result)) !== -1);
    });

    return;
}

// バンドル商品をチェック（削除）
// line_key は本体の行のキー(item.key)。update.js はバリエーションIDの代わりに
// 行のキーでも指定できるので、消すのはこの行だけになる
function checkDeleteBundleItem(line_key) {
    let updateCart = new Object();
    updateCart[line_key] = 0;

    // バンドル商品情報がある場合
    var bundleItems = bundleItemsOfLine(line_key);
    if (typeof( bundleItems ) != 'undefined') {
        // メイン商品の数量（削除する数）。この行の入力欄(data-id=行のキー)から読む
        var mainItemQuantity = Number($('input.quantity__input').filter(function () {
            return $(this).attr('data-id') === line_key;
        }).val());
        // 同じ付属品を複数回指している場合は、その回数分を減らす
        var linkedCounts = {};
        $.each(bundleItems, function(index, value) {
            if (isLinkedBundleItem(line_key, value)) {
                linkedCounts[value] = (linkedCounts[value] || 0) + 1;
            }
        });
        $.each(linkedCounts, function(value, count) {
            // バンドル商品の数量
            var bundleItemQuantity = bundleLineQuantity(value);
            if (isNaN(bundleItemQuantity)) {
                return;
            }
            var targetQuantity = bundleItemQuantity - mainItemQuantity * count;
            if (targetQuantity < 0) {
                targetQuantity = 0;
            }
            updateCart[Number(value)] = targetQuantity;
        });
    }

    // 削除ボタンは画面を再描画しないので update.js で一括処理をして処理後リロード
    $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    async: false,
    data: {updates: updateCart},
    dataType: 'json',
    }).then( window.location.href = "/cart" );

    return;
}
